(function(){
          var btn=document.getElementById('countryBtn');
          var drop=document.getElementById('countryDrop');
          var closeX=document.getElementById('countryClose');
          var search=document.getElementById('countrySearch');
          var list=document.getElementById('countryList');
          if(!btn||!drop)return;
          var isOpen=false;
          function open(){
            isOpen=true;
            drop.style.display='block';
            btn.classList.add('open');
            btn.setAttribute('aria-expanded','true');
            drop.setAttribute('aria-hidden','false');
            if(search)search.value='';
            showAll();
            requestAnimationFrame(function(){
              requestAnimationFrame(function(){ drop.classList.add('open'); });
            });
          }
          function close(){
            isOpen=false;
            drop.classList.remove('open');
            btn.classList.remove('open');
            btn.setAttribute('aria-expanded','false');
            drop.setAttribute('aria-hidden','true');
            setTimeout(function(){ if(!isOpen) drop.style.display=''; },280);
          }
          function showAll(){
            if(!list)return;
            list.querySelectorAll('.country-option').forEach(function(o){ o.style.display=''; });
          }
          function filterOpts(q){
            if(!list)return;
            var ql=q.toLowerCase().trim();
            list.querySelectorAll('.country-option').forEach(function(o){
              o.style.display=(!ql||o.dataset.name.indexOf(ql)>=0||o.dataset.currency.indexOf(ql)>=0||o.dataset.code.indexOf(ql)>=0)?'':'none';
            });
          }
          btn.addEventListener('click',function(e){
            e.preventDefault(); e.stopPropagation();
            isOpen?close():open();
          });
          if(closeX)closeX.addEventListener('click',function(e){e.stopPropagation();close();});
          if(search){
            search.addEventListener('input',function(){filterOpts(search.value);});
            search.addEventListener('keydown',function(e){e.stopPropagation();});
          }
          document.addEventListener('click',function(e){
            if(isOpen&&!drop.contains(e.target)&&!btn.contains(e.target))close();
          });
          document.addEventListener('keydown',function(e){if(e.key==='Escape'&&isOpen)close();});

          /* Escolher um pais aqui passa a mudar tambem a lingua: apaga a
             escolha manual de lingua, para valer a lingua do pais novo.
             Antes a lingua escolhida numa visita anterior continuava a
             ganhar e o site ficava na lingua antiga. */
          var form=document.getElementById('country-form-hdr');
          if(form) {
            form.addEventListener('submit',function() {
              var host=location.hostname, root=host.split('.').slice(-2).join('.');
              var doms=['',host,'.'+host,root,'.'+root], past='Thu, 01 Jan 1970 00:00:00 GMT';
              for(var i=0;i<doms.length;i++){
                document.cookie='pe_lang_pref2=; path=/;'+(doms[i]?' domain='+doms[i]+';':'')+' expires='+past;
                document.cookie='pe_lang_pref=; path=/;'+(doms[i]?' domain='+doms[i]+';':'')+' expires='+past;
              }
              var d=new Date();d.setTime(d.getTime()+365*864e5);
              document.cookie='pe_lang_set=manual;expires='+d.toUTCString()+';path=/;SameSite=Lax';
              document.cookie='pe_lang_set=manual;expires='+d.toUTCString()+';path=/;domain=.'+root+';SameSite=Lax';
            });
          }

          /* Removido: bloco antigo que lia 'pe_translate_lang' do browser e
             forcava essa lingua no Google Translate. Era de um sistema
             anterior e, conforme a ordem de carregamento, sobrepunha-se as
             vezes a escolha nova. */
        })();

;
(function(){
  var wrap = document.querySelector('.nav-item--shop');
  if(!wrap) return;
  var trigger = wrap.querySelector('[data-mega-trigger]');
  var panel = wrap.querySelector('[data-mega-panel]');
  if(!trigger || !panel) return;

  var closeTimer = null;
  var isOpen = false;

  function open(){
    clearTimeout(closeTimer);
    isOpen = true;
    wrap.classList.add('open');
    panel.classList.add('open');
    trigger.setAttribute('aria-expanded','true');
  }
  function close(){
    isOpen = false;
    wrap.classList.remove('open');
    panel.classList.remove('open');
    trigger.setAttribute('aria-expanded','false');
  }
  function scheduleClose(){
    clearTimeout(closeTimer);
    closeTimer = setTimeout(close, 150);
  }

  // Hover-intent (desktop mouse)
  wrap.addEventListener('mouseenter', open);
  wrap.addEventListener('mouseleave', scheduleClose);
  panel.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); });
  panel.addEventListener('mouseleave', scheduleClose);

  // Click / keyboard toggle (touch trackpads, keyboard nav, accessibility)
  trigger.addEventListener('click', function(e){
    e.preventDefault();
    isOpen ? close() : open();
  });

  // Outside click / Escape closes it
  document.addEventListener('click', function(e){
    if(isOpen && !wrap.contains(e.target)) close();
  });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && isOpen) close();
  });

  // Tab switching -- click or hover a category to swap the visible pane
  var tabs = wrap.querySelectorAll('[data-shop-tab]');
  var panes = wrap.querySelectorAll('[data-shop-pane]');
  function activateTab(id){
    tabs.forEach(function(t){
      var on = t.getAttribute('data-shop-tab') === id;
      t.classList.toggle('active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    panes.forEach(function(p){
      p.classList.toggle('active', p.getAttribute('data-shop-pane') === id);
    });
  }
  tabs.forEach(function(t){
    var id = t.getAttribute('data-shop-tab');
    t.addEventListener('click', function(e){ e.preventDefault(); activateTab(id); });
    t.addEventListener('mouseenter', function(){ activateTab(id); });
  });
})();

;
(function(){
  var nav = document.getElementById('mobileNav');

  // Open/close top-level nav items (category accordions)
  document.querySelectorAll('[data-mn]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var id = 'mn-' + btn.getAttribute('data-mn');
      var body = document.getElementById(id);
      var open = btn.classList.contains('open');

      // Close all
      document.querySelectorAll('[data-mn]').forEach(function(b){ b.classList.remove('open'); });
      document.querySelectorAll('.mn-nav-body').forEach(function(b){ b.classList.remove('open'); });
      if(nav) nav.classList.remove('shop-open');

      if(!open && body){
        btn.classList.add('open');
        body.classList.add('open');
        // Hide footer while a category is open for full-screen focus
        if(nav){ nav.classList.add('shop-open'); }
      }
    });
  });

  // Open/close sub-accordions inside Shop -- opening one closes the others
  document.querySelectorAll('[data-mn-sub]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var id = 'mn-' + btn.getAttribute('data-mn-sub');
      var body = document.getElementById(id);
      var open = btn.classList.contains('open');

      // Close all sibling sub-accordions first
      document.querySelectorAll('[data-mn-sub]').forEach(function(b){ b.classList.remove('open'); b.setAttribute('aria-expanded','false'); /* v30 Fase 1J */ });
      document.querySelectorAll('.mn-sub-body').forEach(function(b){ b.classList.remove('open'); });

      if(!open && body){
        btn.classList.add('open');
        btn.setAttribute('aria-expanded','true'); /* v30 Fase 1J: estado aberto para leitores de ecra */
        body.classList.add('open');
      }
    });
  });
  /* -- v12 FX: tap ripples on every interactive row -- */
  var rippleSel = '.mn-nav-direct, .mn-nav-btn, .mn-sub-btn, .mn-all-link, .mn-sub-body a, .mn-foot-row a, .mn-foot-link';
  document.addEventListener('pointerdown', function(e){
    var row = e.target.closest ? e.target.closest(rippleSel) : null;
    if(!row || !nav || !nav.contains(row)) return;
    var r = row.getBoundingClientRect();
    var d = Math.max(r.width, r.height) * 2;
    var s = document.createElement('span');
    s.className = 'mn-ripple notranslate';
    s.setAttribute('translate','no');
    s.style.width = s.style.height = d + 'px';
    s.style.left = (e.clientX - r.left) + 'px';
    s.style.top  = (e.clientY - r.top) + 'px';
    row.appendChild(s);
    setTimeout(function(){ if(s.parentNode) s.parentNode.removeChild(s); }, 700);
  }, {passive:true});

  /* -- v12 FX: burger -> X morph, synced to drawer state -- */
  if(nav && 'MutationObserver' in window){
    var sync = function(){
      document.body.classList.toggle('mn-open', nav.classList.contains('on'));
    };
    new MutationObserver(sync).observe(nav, {attributes:true, attributeFilter:['class']});
    sync();
  }
})();

;
/* -- Pais por defeito: Portugal na primeira visita --
   So no dominio principal. Nos subdominios de pais (fr., de., it., es.)
   nao mexe: era isto que mandava um cliente de volta para Portugal logo
   depois de ele escolher outro pais. Tambem nao corre se o cliente ja
   escolheu pais ou lingua. */
(function(){
  try{
    var host=location.hostname, parts=host.split('.');
    var isRoot = parts.length===2 || (parts.length===3 && parts[0]==='www');
    if(!isRoot) return;
    if(host.indexOf('myshopify.com')>-1) return;
    var ck=document.cookie;
    if(ck.indexOf('pe_lang_set=')>-1 || ck.indexOf('pe_rgn=')>-1 || ck.indexOf('pe_lang_pref2=')>-1) return;
    var img=document.querySelector('#countryBtn .country-btn-flag-img');
    var m=img&&img.src&&img.src.match(/w20\/([a-z]{2})\.png/);
    var cur=m?m[1].toUpperCase():null;
    if(!cur||cur==='PT') return;
    /* v43: os 27 paises da UE estao todos no mercado Europa (pureethical.com) - nao se troca o pais deles para Portugal; a lingua segue o pais (/de, /fr, /es, /it) */
    if(/^(AT|BE|BG|CY|CZ|DE|DK|EE|ES|FI|FR|GR|HR|HU|IE|IT|LT|LU|LV|MT|NL|PL|RO|SE|SI|SK)$/.test(cur)) return;
    var form=document.getElementById('country-form-hdr');
    if(!form) return;
    var opt=form.querySelector('button[name="country_code"][value="PT"]');
    if(!opt) return;
    var root=parts.slice(-2).join('.');
    var d=new Date();d.setTime(d.getTime()+365*864e5);
    document.cookie='pe_lang_set=auto;expires='+d.toUTCString()+';path=/;SameSite=Lax';
    document.cookie='pe_lang_set=auto;expires='+d.toUTCString()+';path=/;domain=.'+root+';SameSite=Lax';
    opt.click();
  }catch(e){}
})();

;
/* -- Newsletter da homepage centrada -- */
(function(){
  var st=document.createElement('style');
  st.textContent='html body .nh-nl{align-items:center!important;text-align:center!important}html body .nh-nl-form{margin-left:auto!important;margin-right:auto!important;max-width:440px!important;width:100%!important;justify-content:center!important}';
  document.head.appendChild(st);
})();

;
/* -- PE: enriquecer painel de pesquisa (estilo Gymshark: tendencias + cartoes de Novidades como a home) -- desktop only -- */
(function(){
  if(!window.matchMedia||!window.matchMedia('(min-width:1000px)').matches) return;
  var PE=[['Novidades','/collections/new-arrivals'],['Mais vendidos','/collections/best-sellers'],['Homem','/collections/homem'],['Mulher','/collections/mulher'],['Malas & Acessorios','/collections/malas-acessorios'],['Promocoes','/collections/sale']];
  function enrich(){
    var sp=document.getElementById('searchPanel');
    if(!sp) return false;
    if(sp.getAttribute('data-pe-srch')) return true;
    sp.setAttribute('data-pe-srch','1');
    /* v29: os atalhos ja vem traduzidos do Liquid (layout/theme.liquid); antes eram substituidos aqui
       por textos fixos em portugues sem acentos ("Promocoes", "Mais vendidos") em todas as linguas */
    if(!sp.querySelector('.pe-srch-prodwrap')){
      var block=document.createElement('div');
      block.className='pe-srch-prodwrap';
      var peSg=document.getElementById('peSearchSuggest');
      var peNewLbl=(peSg&&peSg.getAttribute('data-t-new'))||'Novidades';
      block.innerHTML='<p class="search-label pe-srch-plabel"></p><div class="pe-srch-prods pe-srch-loading"></div>';
      block.querySelector('.pe-srch-plabel').textContent=peNewLbl;
      sp.appendChild(block);
      var grid=block.querySelector('.pe-srch-prods');
      /* v27: so vai buscar as novidades quando o painel de pesquisa abre (antes descarregava a colecao inteira em todas as paginas) */
      var peLoaded=false;
      function peLoadNew(){
      if(peLoaded) return; peLoaded=true;
      fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'collections/new-arrivals').then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var cards=doc.querySelectorAll('.product-card');
        grid.classList.remove('pe-srch-loading');
        var n=Math.min(4,cards.length);
        for(var i=0;i<n;i++){
          var c=document.importNode(cards[i],true);
          var ii=c.querySelectorAll('img');
          /* v27: imagens ficam lazy */
          grid.appendChild(c);
        }
        if(window.syncWishlistUI){ try{ syncWishlistUI(); }catch(e){} }
      }).catch(function(){
        grid.classList.remove('pe-srch-loading');
        if(block.parentNode) block.parentNode.removeChild(block);
      });
      }
      function peIsOpen(){ return sp.classList.contains('open')||sp.classList.contains('active')||sp.classList.contains('is-open')||sp.getAttribute('aria-hidden')==='false'; }
      if(peIsOpen()){ peLoadNew(); }
      else {
        var peMo=new MutationObserver(function(){ if(peIsOpen()){ peMo.disconnect(); peLoadNew(); } });
        peMo.observe(sp,{attributes:true,attributeFilter:['class','aria-hidden','style']});
      }
    }
    return true;
  }
  if(!enrich()){
    var t=0;
    var iv=setInterval(function(){ t++; if(enrich()||t>60) clearInterval(iv); },120);
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',enrich);
  }
})();
